import React from "react";
import { useStoreStatus } from "../context/StoreStatusContext";

export default function ClosedBanner() {
  const { isOpen } = useStoreStatus();
  if (isOpen) return null;
  return (
    <div
      className="bg-[#C85A5A] text-white text-center text-sm font-bold py-2 px-4"
      data-testid="closed-banner"
      role="alert"
    >
      Sorry, we are closed today!
    </div>
  );
}
